import type { SaveV0Data } from "@dd/schema";
import Dexie, { type EntityTable } from "dexie";

/**
 * Persistencia local (IndexedDB vía Dexie, decisión C4).
 * v1: tabla kv (flags de shell, credencial).
 * v2 (F0-T15): tabla saves — una partida por caso; el event log ES el save.
 */

interface KVRow {
  key: string;
  value: unknown;
}

export interface SaveRow extends SaveV0Data {
  /** Clave primaria: una partida automática por caso (`auto-<caseId>`) */
  saveId: string;
}

class ArgosDB extends Dexie {
  kv!: EntityTable<KVRow, "key">;
  saves!: EntityTable<SaveRow, "saveId">;

  constructor() {
    super("argos");
    this.version(1).stores({ kv: "key" });
    this.version(2).stores({ kv: "key", saves: "saveId" });
  }
}

export const db = new ArgosDB();

export async function getKV<T>(key: string): Promise<T | undefined> {
  const row = await db.kv.get(key);
  return row?.value as T | undefined;
}

export async function setKV(key: string, value: unknown): Promise<void> {
  await db.kv.put({ key, value });
}
